import Block from './Block.vue';
export default Block;



// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/components/block/index.ts